import { apiService } from "../services/api.service";
import Moment from "moment";
// import log from "loglevel";
import { LogLevel } from "../enums";

export const logController = {
    getLogsByUzivatelOrSklad,
    logMessage,
    // addLocalLogMessage,
    // sendLocalLogMessagesToServer
};

function getLogsByUzivatelOrSklad(filter) {
    var parameters = "";
    if (filter) {
        filter.filters.forEach((element) => {
            if (element.field == "date") {
                parameters += element.field + "=" + Moment(element.value).format("YYYY-MM-DD") + "&";
            } else parameters += element.field + "=" + element.value + "&";
        });
    }

    return apiService.fetchApiRequest(`api/Log/GetLogs?` + parameters);
}

function logMessage(msg, logLevel = 2) {
    // if (logLevel == LogLevel.Information) log.info(msg);
    // else if (logLevel == LogLevel.Warning) log.warn(msg);
    // else if (logLevel == LogLevel.Error || logLevel == LogLevel.Critical) log.error(msg);
    // else log.debug(msg);
    
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ msg: msg, logLevel: logLevel })
    };

    apiService.fetchApiRequest("api/Log/LogMessage", false, requestOptions);
}

function addLocalLogMessage(msg, logLevel = 2) {
    var localLogMessages = localStorage.getItem("localLogMessages");
    var logMessages = localLogMessages || localLogMessages !== null ? JSON.parse(localLogMessages) : [];
    logMessages.push({ msg: msg, logLevel: logLevel });
    localStorage.setItem("localLogMessages", JSON.stringify(logMessages));
}

function sendLocalLogMessagesToServer() {
    var localLogMessages = localStorage.getItem("localLogMessages");
    if (localLogMessages && localLogMessages !== null) {
        localStorage.removeItem("localLogMessages");
        var logMessages = JSON.parse(localLogMessages);
        logMessages.forEach((log) => {
            logMessage(log.msg, log.logLevel);
        });
    }
}



// WEBPACK FOOTER //
// ./src/controllers/log.controller.js